/**
 * Formats a course or student for display as `Name (ID)` — the friendly name
 * first, with the raw identifier in parentheses. Falls back to the bare id
 * when no name is available (or when the name is just the id again), so call
 * sites can pass a possibly-null name unconditionally.
 *
 * Mirrors the backend `CourseLabel` / `StudentLabel` helpers (Stage 3
 * validator) so the wording matches between server-built issue messages and
 * client-rendered labels.
 */
export function formatEntityLabel(
  name: string | null | undefined,
  id: string,
): string {
  const trimmed = name?.trim();
  if (!trimmed || trimmed.toLowerCase() === id.trim().toLowerCase()) {
    return id;
  }
  return `${trimmed} (${id})`;
}
